// extracted by mini-css-extract-plugin
export default {"banner":"connection-banner_banner__NBVKK","text":"connection-banner_text__QuWnx"};